export const FORM_BODY_MAX_WIDTH = 452;
export const FORM_MAX_WIDTH = 686;
